module.exports = __webpack_public_path__ + "create/static/media/terms.9cffcad6.xhtml";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/shared/ModalTerms/terms.xhtml
// module id = 334
// module chunks = 39